if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        if (!this.form) {
          console.error('product-form: form not found')
          return
        }

        this.variantIdInput.disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))

        this.submitButton = this.querySelector('[type="submit"]')
        if (!this.submitButton) {
          console.error('product-form: submit button not found')
          return
        }

        this.submitButtonText = this.submitButton.querySelector('span')
        if (!this.submitButtonText) {
          console.error('product-form: submit button text span not found')
          return
        }

        if (document.querySelector('cart-drawer') && this.submitButton)
          this.submitButton.setAttribute('aria-haspopup', 'dialog')

        this.hideErrors = this.dataset.hideErrors === 'true'
      }

      getCart() {
        return (
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        )
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        const cart = this.getCart()
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              })
              this.handleErrorMessage(response.description)

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButtonText.classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else {
              const cart = this.getCart()
              if (!cart) {
                console.warn(
                  'product-form: cart-notification or cart-drawer not found, redirecting to cart page'
                )
                window.location = window.routes.cart_url
                return
              }

              // Verify response has sections
              if (!response.sections) {
                console.error(
                  'product-form: response does not have sections property',
                  response
                )
                return
              }

              const startMarker = CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              )
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker(
                    'add:wait-for-subscribers',
                    startMarker
                  )
                })
              this.error = false
              const quickAddModal = this.closest('quick-add-modal')
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure(
                        'add:paint-updated-sections',
                        () => {
                          if (cart && response.sections) {
                            // Ensure response has the key property for cart-notification
                            if (
                              !response.key &&
                              response.items &&
                              response.items.length > 0
                            ) {
                              response.key =
                                response.items[response.items.length - 1].key
                            }
                            cart.renderContents(response)
                          }
                        }
                      )
                    })
                  },
                  { once: true }
                )
                quickAddModal.hide(true)
              } else {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  if (cart && response.sections) {
                    // Ensure response has the key property for cart-notification
                    if (
                      !response.key &&
                      response.items &&
                      response.items.length > 0
                    ) {
                      response.key =
                        response.items[response.items.length - 1].key
                    }
                    cart.renderContents(response)
                  }
                })
              }
            }
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading')
              if (!this.error)
                this.submitButton.removeAttribute('aria-disabled')
            }
            const cart = this.getCart()
            if (cart && cart.classList.contains('is-empty'))
              cart.classList.remove('is-empty')
            const loadingSpinner = this.querySelector('.loading__spinner')
            if (loadingSpinner) {
              loadingSpinner.classList.add('hidden')
            }

            CartPerformance.measureFromEvent('add:user-action', evt)
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled')
          if (text) this.submitButtonText.textContent = text
        } else {
          this.submitButton.removeAttribute('disabled')
          this.submitButtonText.textContent = window.variantStrings.addToCart
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]')
      }
    }
  )
}
